// extracted by mini-css-extract-plugin
module.exports = {"outside-container":"timerComponent_outside-container__pKhhH","container":"timerComponent_container__34VDz"};